import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";
import zIndexTypes from "../../../theme/zIndexTypes";

export const Wrapper = styled.div``;

export const AddButton = styled.a`
  cursor: pointer;
  position: fixed;
  right: 20px;
  top: 68px;
  z-index: ${zIndexTypes.actionBarItem};
  background-color: #79D9D9;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  transition: all 0.2s ease-in-out 0s;

  svg {
    color: #fff;
    transition: all 0.2s ease-in-out 0s;
    font-size: 1.2em;
  }

  &:hover {
    background-color: #fff;

    svg {
      color: #402680;
    }
  }

  ${mediaMaxWidth.smallDesktop} {
    right: 5px;
  }

  ${mediaMaxWidth.tablet} {
    right: 45px;

    &.downScroll {
      top: 8px;
    }
  }
`;
